import { InteropTest } from "./Interoptest";
import { ThemeHelper } from "./ThemeHelper";
import { AnimeTest} from "./AnimeTest";
import {SplashAnimations} from "./SplashAnimations";
import {NavigationAnimations} from "./NavigationAnimations";

// This object will be the single point of entry for all Blazor-JS interop modules.
const BlazorInterop = {
    splashAnimations: new SplashAnimations(),
    navigationAnimations: new NavigationAnimations(),
    interopTest: new InteropTest(),
    themeHelper: new ThemeHelper(),
    animeTest: new AnimeTest()
};

// Expose the main interop object on the window for Blazor to access.
declare global {
    interface Window {
        nfjs: typeof BlazorInterop;
    }
}

window.nfjs = BlazorInterop;